    import React from "react";
    import { motion } from "framer-motion";
    import "./../styles/WhyJoinSection.css";

    const cards = [
    {
        icon: "🚀",
        title: "Innovation First",
        description: "Work on cutting-edge projects that push the boundaries of technology",
    },
    {
        icon: "🌱",
        title: "Growth Focused",
        description: "Continuous learning opportunities and career development programs",
    },
    {
        icon: "🤝",
        title: "Collaborative Culture",
        description: "Work with talented teammates in an inclusive and supportive environment",
    },
    ];

    const containerVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
        staggerChildren: 0.2,
        },
    },
    };

    const cardVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    };

    export default function WhyJoinSection() {
    return (
        <section className="why-join-section">
        <div className="why-join-container">
            <motion.h2
            className="why-join-title"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            >
            Why Join <span>NexaGrowth Africa?</span>
            </motion.h2>
            <motion.p
            className="why-join-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            >
            We're building the future with a team of passionate innovators. Join us and be part of something extraordinary.
            </motion.p>

            <motion.div
            className="why-join-cards"
            variants={containerVariant}
            initial="hidden"
            animate="visible"
            >
            {cards.map((card, index) => (
                <motion.div className="why-join-card" key={index} variants={cardVariant}>
                <div className="why-join-icon">{card.icon}</div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                </motion.div>
            ))}
            </motion.div>
        </div>
        </section>
    );
    }
